import { api } from '@services';

interface IPatchRequest {
  studioId: string;
}
const deleteCustomField = async ({
  studioId,
}: IPatchRequest): Promise<void> => {
  await api.delete(`/customFields/${studioId}`);
};

export { deleteCustomField };
